<template>
<div>
    <div class="form-container ou-donation-form">
        <div class="holder">
            <PaymentForm class="form-horizontal">                
                <FormSection>
                    <AmountSelectorList nocustom="nocustom"/>                    
                    <ErrorLabel field="amount" />
                    <TransactionFee />
                </FormSection>
                <FormSection last>
                    <FormRow inline>      
                        <FormCol field="title" :flex="1" />
                        <FormCol field="firstName" :flex="2" />
                        <FormCol field="lastName" :flex="2" />
                    </FormRow>
                    <FormRow inline>
                        <FormCol field="email" />
                        <FormCol field="phone" />
                    </FormRow>  
                    <FormRow inline>
                      <Consent privacy="https://www.ouisrael.org/privacy-policy/"/>
                  </FormRow>                                       
                    <DonorAddress />
                </FormSection>
                    <FormRow inline>
                      <FormCol field="card" :showLabel="false"/>
                    </FormRow>
                <PaymentButton showAmount btnText="Donate"/>
            </PaymentForm>
        </div>
    </div>
</div>
</template>
<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}
.other-means {
  font-size: 14px;
  line-height: 1.6;
}
::v-deep .amount-row {
  @media (min-width: 720px) {
    min-width: 31%;
    max-width: 31%;
  }
}
</style>

